import React from 'react';
import {
  createSelectionColumn,
  ExplorerStyledDisplayGrid,
  FeatureFlagsContext,
  GraphQLError,
  GridSortProps,
  reportGraphQLErrors,
  SelectionProviderChildProps,
  SiteUrlsContext,
  TypedColumn,
  UsualDisplayGridProps
} from '../../../data-catalog-shared';

import { columns } from '../sharedDisplayGrid/TablesDisplayGrid';
import { TablesValidSortFields } from '../sorting/sortProviders/TablesGridSortProvider';
import { TablesDisplayGridRowData } from '../table/types/TablesDisplayGridRowData';

export type DatabaseTablesDisplayGridProps =
  UsualDisplayGridProps<TablesDisplayGridRowData, GraphQLError> &
  GridSortProps<TablesValidSortFields> &
  SelectionProviderChildProps;

export function DatabaseTablesDisplayGrid(props: DatabaseTablesDisplayGridProps): JSX.Element {
  const { publishedConnectionsLineageEnabled} = React.useContext(FeatureFlagsContext);
  const siteUrls = React.useContext(SiteUrlsContext);
  const cols: TypedColumn<TablesDisplayGridRowData, TablesValidSortFields>[] = [
    createSelectionColumn(),
    ...columns(siteUrls).map(columnFactory => columnFactory(props))
      .filter(column => {
        if (column.name === 'virtualConnections' && !publishedConnectionsLineageEnabled) {
          return false;
        }
        if (column.name === 'warning' || column.name === 'certification') {
          return false;
        }
        if (column.name === 'database') {
          return false;
        }
        return true;
      })
  ];

  return (
    <ExplorerStyledDisplayGrid
      columns={cols}
      rowStore={props.rowStore}
      selectedKeys={props.selectedKeys}
      updateSelectionForKey={props.updateSelectionForKey}
      rowCount={props.rowCount}
      renderErrors={reportGraphQLErrors}
      orderBy={props.orderBy}
      updateSortOrder={props.updateSortOrder}
    />
  );
}
